import { styled } from '../../../utils/styled';
import { propStyles } from '../../../utils/propStyles';

const StyledComponent = styled<any, any>('div', 'dropdownWrapper', 'dropdown')`
    ${propStyles};
`;

StyledComponent.defaultProps = {
    flex: '1 0 100%',
    paddingY: 'sm',
    bgColor: 'white',
};

export default StyledComponent;



// WEBPACK FOOTER //
// ./src/Components/Dropdown/StyledComponents/DropdownWrapper.tsx